// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button-module__btn"};